import { useState } from 'react';

import styles from './CartLogin.module.scss';

import { AuthModal } from '@/features/auth/ui/AuthModal/AuthModal';
import { Button } from '@/shared/ui-kit/Button/Button';

export const CartLogin = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      {import.meta.env.DEV && (
        <Button className={styles.loginBtn} onClick={handleOpen}>
          Войти по номеру телефона
        </Button>
      )}

      {open && <AuthModal open={open} onClose={handleClose} />}
    </>
  );
};
